module.exports = __webpack_public_path__ + "media/images/front/icon_new_01-5193509932e0d6cb3d25720b3dd0d2ae.svg";